import React, { useState } from "react";
import FormComponent from "./form";

const BookNow = () => {
  const [showForm, setShowForm] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);

  const cards = [
    { 
      id: 1,
      title: "Executive Car", 
      description: "Luxury ride with premium service.", 
      carImg: "/exe.png", 
      pass: "4", 
      suit: "2", 
      hand: "2",
      features: ["4 Passengers", "2 Suitcases", "2 Hand Luggage"],
      priceRange: "£50-£100"
    },   
    { 
      id: 2,
      title: "Saloon Car", 
      description: "Affordable and comfortable travel", 
      carImg: "/saloon.png", 
      pass: "4", 
      suit: "2", 
      hand: "2",
      features: ["4 Passengers", "2 Suitcases", "2 Hand Luggage"],
      priceRange: "£80-£150"
    },
    { 
      id: 3,
      title: "MPV Car", 
      description: "Spacious car for family trips", 
      carImg: "/mpv (3).png", 
      pass: "4", 
      suit: "4", 
      hand: "4",
      features: ["4 Passengers", "4 Suitcases", "4 Hand Luggage"],
      priceRange: "£70-£120"
    },
    { 
      id: 4,
      title: "8 Seater", 
      description: "Exclusive VIP travel experience", 
      carImg: "/8-seater.png", 
      pass: "8", 
      suit: "6", 
      hand: "6",
      features: ["8 Passengers", "6 Suitcases", "6 Hand Luggage"],
      priceRange: "£120-£200"
    },
  ];

  const handleSelectCard = (card) => {
    setSelectedCard(card); 
    setShowForm(true);
    // Prevent scrolling when modal is open
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModal = () => {
    setShowForm(false);
    // Restore scrolling
    document.body.style.overflow = 'auto';
  };

  return (
    <>
      <section className="bg-gradient-to-b from-gray-900 to-gray-800 py-16" id="book-now">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">
              Choose Your Perfect Ride
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Select your vehicle, enter your journey details, and get an instant quote
            </p>
          </div>

          {/* Vehicle Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {cards.map((card) => (
              <div
                key={card.id}
                onClick={() => handleSelectCard(card)}
                onMouseEnter={() => setHoveredCard(card.id)}
                onMouseLeave={() => setHoveredCard(null)}
                className={`relative bg-gray-800 rounded-xl overflow-hidden shadow-lg transition-all duration-300 transform hover:-translate-y-2 cursor-pointer border-2 ${
                  selectedCard?.id === card.id 
                    ? "border-yellow-400 shadow-xl shadow-yellow-400/20" 
                    : "border-transparent"
                }`}
              >
                {/* Popular badge */}
                {card.id === 3 && (
                  <div className="absolute top-4 right-4 bg-yellow-500 text-gray-900 text-xs font-bold px-3 py-1 rounded-full z-10">
                    MOST POPULAR
                  </div>
                )}
                
                {/* Vehicle Image */}
                <div className="h-48 bg-gray-700 flex items-center justify-center p-4">
                  <img 
                    src={card.carImg} 
                    alt={card.title} 
                    className={`h-full object-contain transition-transform duration-300 ${
                      hoveredCard === card.id ? "scale-110" : "scale-100"
                    }`}
                  />
                </div>
                
                {/* Card Content */}
                <div className="p-6">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-xl font-bold text-white">{card.title}</h3>
                    {/* <span className="text-yellow-400 font-medium">{card.priceRange}</span> */}
                  </div>
                  
                  <p className="text-gray-400 mb-4">{card.description}</p>
                  
                  
                  
                  {/* Features List */}
                 <ul className="mb-6">
  {card.features.map((feature, i) => {
    // Define different icons for each feature
    const icons = [
      <svg key="passengers" className="w-4 h-4 mr-2 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>,
      <svg key="suitcase" className="w-4 h-4 mr-2 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>,
      <svg key="luggage" className="w-4 h-4 mr-2 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
      </svg>
    ];
    
    return (
      <li key={i} className="flex items-center text-gray-300 text-sm mb-2">
        {icons[i % icons.length]}  {/* Cycle through icons */}
        {feature}
      </li>
    );
  })}
</ul>
                  
                  {/* Select Button */}
                  <button 
                    className={`w-full py-3 px-4 rounded-lg font-medium transition-colors ${
                      selectedCard?.id === card.id
                        ? "bg-yellow-500 text-gray-900 hover:bg-yellow-600"
                        : "bg-gray-700 text-white hover:bg-gray-600"
                    }`}
                  >
                    {selectedCard?.id === card.id ? "Selected" : "Select Vehicle"}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal Form */}
      {showForm && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          {/* Overlay */}
          <div className="fixed inset-0 bg-black bg-opacity-75 transition-opacity"></div>
          
          {/* Modal Container */}
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            {/* Modal Content - Increased width to 90% */}
            <div className="inline-block align-bottom bg-gray-800 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-[90%] max-w-4xl">
              {/* Close Button */}
              <div className="absolute top-0 right-0 pt-4 pr-4 z-10">
                <button
                  onClick={handleCloseModal}
                  className="text-gray-400 hover:text-white focus:outline-none"
                >
                  <span className="sr-only">Close</span>
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              
              {/* Form Component */}
              <div className="bg-gray-900 px-4 pt-5 pb-4 w-full overflow-y-auto">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                    <h3 className="text-lg leading-6 font-medium text-white mb-4">
                      Booking Your <span className="text-yellow-400">{selectedCard.title}</span>
                    </h3>
                    <FormComponent selectedVehicle={selectedCard} onClose={handleCloseModal} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BookNow;